// extracted by mini-css-extract-plugin
module.exports = {"form":"ForgotPassword_form__1LlHy","label":"ForgotPassword_label__yStzf","backToLogin":"ForgotPassword_backToLogin__3HI05"};